import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { useGroupGet } from "hooks/citajteo/dl_group/useGroupGet";
import { useGroupUpdate } from "hooks/citajteo/dl_group/useGroupUpdate";
import { QUERY_KEYS } from "constant/react_query";
import DlGroupForm, {
  DL_GROUP_EMPTY_FORM,
  DlGroupFormState,
} from "components/admin/common/dl_group/DlGroupForm/DlGroupForm";
import toast from "react-hot-toast";
import { useFieldArray, useForm } from "react-hook-form";
import {
  fCondArrFormat,
  fCondObFormat,
} from "components/admin/common/dl_group/DlGroupForm/DlGroupForm.logic";
import { UnitFieldCond } from "common/api/citajteo/dl_group/citajteo_group";

const buildFormFromGroup = (group: any): DlGroupFormState => ({
  slug: group.slug ?? "",
  fieldConditions: fCondArrFormat(group.fCond ?? {}),
});

const DlGroupEdit: React.FC = () => {
  const { itemId = "" } = useParams<{ itemId: string }>();
  const group = useGroupGet(itemId);
  const { groupUpdateMutate } = useGroupUpdate({
    invalidateKeysArray: [
      [QUERY_KEYS.CITAJTEO_DL_GROUP_SEARCH],
      [QUERY_KEYS.CITAJTEO_DL_GROUP_GET, itemId],
    ],
  });
  const {
    control,
    handleSubmit: handleFormSubmit,
    reset,
  } = useForm<DlGroupFormState>({
    defaultValues: DL_GROUP_EMPTY_FORM,
  });
  const [errorText, setErrorText] = useState("");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "fieldConditions",
  });

  const fieldArrayHandlers = { fields, append, remove };

  useEffect(() => {
    if (group) {
      reset(buildFormFromGroup(group));
    }
  }, [group, reset]);

  const handleSubmit = (form: DlGroupFormState) => {
    setErrorText("");

    const trimmedSlug = form.slug.trim();

    if (trimmedSlug === "") {
      setErrorText("Slug ne sme biti prazan.");
      return;
    }

    let fCond: UnitFieldCond = fCondObFormat(form.fieldConditions);

    const updatePayload = {
      slug: trimmedSlug,
      fCond,
    };

    console.log("handleSubmit", form, updatePayload);

    groupUpdateMutate(
      { id: itemId, updatePayload },
      {
        onSuccess: () => {
          toast.success("Uspešno ažuriranje odrednice.");
        },
        onError: (error) => {
          console.error("Error updating group:", error);
          toast.error("Greška prilikom ažuriranja odrednice.");
        },
      },
    );
  };

  const handleReset = () => {
    if (group) {
      reset(buildFormFromGroup(group));
    } else {
      reset(DL_GROUP_EMPTY_FORM);
    }
    setErrorText("");
  };

  if (!group) {
    return <FullWidth>Učitavanje odrednice...</FullWidth>;
  }

  return (
    <FullWidth>
      <div className="App">
        <DlGroupForm
          control={control}
          fieldArrayHandlers={fieldArrayHandlers}
          errorText={errorText}
          isEditMode
          onSubmit={handleFormSubmit(handleSubmit)}
          onReset={handleReset}
        />
      </div>
    </FullWidth>
  );
};

export default DlGroupEdit;

const FullWidth = styled.div`
  width: 100%;
`;
